export default __webpack_public_path__ + "media/images/male200-060a1e6c417a711faf8e8a711c833bf7.png";